<template>
  <fieldset>
    <component :is="'field-' + field.type" :field="field" :packages="packages"></component>
    <template v-if="extended">
      <styled-text :text="field.text" light></styled-text>
      <configurator-gallery :images="field.images" inline></configurator-gallery>
    </template>
  </fieldset>
</template>

<script>
import FieldRange from './FieldRange.vue';
import FieldNumber from './FieldNumber.vue';
import FieldNumberToSquareCalculatedFromSubfields from './FieldNumberToSquareCalculatedFromSubfields.vue';
import FieldSelect from './FieldSelect.vue';
import FieldCheck from './FieldCheck.vue';
import FieldCheckExtended from './FieldCheckExtended.vue';
import FieldRadioImage from './FieldRadioImage.vue';
import FieldPackage from './FieldPackage.vue';
import FieldText from './FieldText.vue';
import StyledText from "../StyledText";
import ConfiguratorGallery from "../ConfiguratorGallery";

export default {
  components: {
    ConfiguratorGallery,
    StyledText,
    FieldNumber,
    FieldRange,
    FieldNumberToSquareCalculatedFromSubfields,
    FieldSelect,
    FieldCheck,
    FieldCheckExtended,
    FieldRadioImage,
    FieldPackage,
    FieldText
  },
  props: {
    field: Object,
    packages: Object,
    extended: Boolean
  }
}
</script>